import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Route } from 'react-router-dom';

import { PAGE_ROUTE }     from '../constants';
import PrivateRoute       from './private';

import PageAbout          from '../pages/about';
import PageClasses        from '../pages/classes';
import PageClient         from '../pages/client';
import PageContact        from '../pages/contact';
import PageDashboard      from '../pages/dashboard';
import PageDeposito       from '../pages/validacoes';
import PageDepositolog    from '../pages/depositolog';
import PageHome           from '../pages/home';
import PageLogs           from '../pages/logs';
import PageOperations     from '../pages/operations';
import PageSaques         from '../pages/saquelog';
import PageSchools        from '../pages/schools';
import PageSeries         from '../pages/series';
import PageSignin         from '../pages/signin';
import PageTransferencias from '../pages/transferencialog';
import PageUsers          from '../pages/users';
import PageUsersStore     from '../pages/users/store';
import PageValidacoes     from '../pages/validacoes';

import PageTest           from '../pages/test';
import PageTest2          from '../pages/test2';

export default function Routes() {
  return (
    <BrowserRouter>
      <PrivateRoute exact component={PageClient}         path={PAGE_ROUTE.CLIENT}                 client={PageClient} />
      <PrivateRoute exact component={PageDashboard}      path={PAGE_ROUTE.DASHBOARD}              client={PageClient} />
      <PrivateRoute exact component={PageValidacoes}     path={PAGE_ROUTE.VALIDACOES}             client={PageClient} />
      <PrivateRoute exact component={PageDeposito}       path={PAGE_ROUTE.DEPOSITO}               client={PageClient} />
      <PrivateRoute exact component={PageDepositolog}    path={PAGE_ROUTE.DEPOSITOLOGS}           client={PageClient} />
      <PrivateRoute exact component={PageLogs}           path={PAGE_ROUTE.LOGS}                   client={PageClient} />
      <PrivateRoute exact component={PageOperations}     path={PAGE_ROUTE.OPERATIONS}             client={PageClient} />
      <PrivateRoute exact component={PageSaques}         path={PAGE_ROUTE.SAQUES}                 client={PageClient} />
      <PrivateRoute exact component={PageSchools}        path={PAGE_ROUTE.SCHOOLS}                client={PageClient} />
      <PrivateRoute exact component={PageTransferencias} path={PAGE_ROUTE.TRANSFERENCIAS}         client={PageClient} />
      <PrivateRoute exact component={PageUsers}          path={PAGE_ROUTE.USERS}                  client={PageClient} />
      <PrivateRoute exact component={PageUsersStore}     path={PAGE_ROUTE.USERS_STORE}            client={PageClient} />
      <PrivateRoute exact component={PageUsersStore}     path={PAGE_ROUTE.USERS_UPDATE + "/:id"}  client={PageClient} />
      <PrivateRoute exact component={PageSeries}         path={PAGE_ROUTE.SERIES + "/:school_id"} client={PageClient} />
      <PrivateRoute exact component={PageClasses}        path={PAGE_ROUTE.CLASSES + "/:serie_id"} client={PageClient} />
      <Route        exact component={PageAbout}          path={PAGE_ROUTE.ABOUT}                  />
      <Route        exact component={PageContact}        path={PAGE_ROUTE.CONTACT}                />
      <Route        exact component={PageHome}           path={PAGE_ROUTE.HOME}                   />
      <Route        exact component={PageSignin}         path={PAGE_ROUTE.ROOT}                   />
      <Route        exact component={PageSignin}         path={PAGE_ROUTE.SIGNIN}                 />
      <Route        exact component={PageTest}           path={PAGE_ROUTE.TEST}                   />
      <Route        exact component={PageTest2}          path={PAGE_ROUTE.TEST2}                  />
    </BrowserRouter>
  );
}
